module.exports = __webpack_public_path__ + "img/menu-8.3ebfe3c7.svg";